import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
// eslint-disable-next-line no-unused-vars
import { SchoolInterface, SchoolsTypes, CourseInterface } from './types';

// List Schools
export const listSchoolsRequest = (payload: object) =>
  action(SchoolsTypes.LIST_SCHOOLS_REQUEST, payload);
export const listSchoolsSuccess = (payload: {
  schoolsList: SchoolInterface[];
  schoolsListFull: SchoolInterface[];
  isCsvFull?: boolean;
  totalCount: number;
}) => action(SchoolsTypes.LIST_SCHOOLS_SUCCESS, payload);
export const listSchoolsFailure = () =>
  action(SchoolsTypes.LIST_SCHOOLS_FAILURE);

// Get School
export const getSchoolRequest = (payload: object) =>
  action(SchoolsTypes.GET_SCHOOL_REQUEST, payload);
export const getSchoolSuccess = (payload: { schoolData: SchoolInterface }) =>
  action(SchoolsTypes.GET_SCHOOL_SUCCESS, payload);
export const getSchoolFailure = () => action(SchoolsTypes.GET_SCHOOL_FAILURE);

// Filter Schools
export const filterSchoolsRequest = (payload: object) =>
  asyncAction(SchoolsTypes.FILTER_SCHOOLS_REQUEST, payload);
export const filterSchoolsSuccess = (payload: {
  schoolsList: SchoolInterface[];
  totalCount: number;
}) => action(SchoolsTypes.FILTER_SCHOOLS_SUCCESS, payload);
export const filterSchoolsFailure = () =>
  action(SchoolsTypes.FILTER_SCHOOLS_FAILURE);

// Filter Schools
export const filterCoursesRequest = (payload: object) =>
  asyncAction(SchoolsTypes.FILTER_COURSES_REQUEST, payload);
export const filterCoursesSuccess = (payload: {
  coursesList: CourseInterface[];
  totalCount: number;
}) => action(SchoolsTypes.FILTER_COURSES_SUCCESS, payload);
export const filterCoursesFailure = () =>
  action(SchoolsTypes.FILTER_COURSES_FAILURE);

// Create School
export const createSchoolRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => action(SchoolsTypes.CREATE_SCHOOL_REQUEST, payload);
export const createSchoolSuccess = (payload: { schoolData: SchoolInterface }) =>
  action(SchoolsTypes.CREATE_SCHOOL_SUCCESS, payload);
export const createSchoolFailure = () =>
  action(SchoolsTypes.CREATE_SCHOOL_FAILURE);

// Update School
export const updateSchoolRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => action(SchoolsTypes.UPDATE_SCHOOL_REQUEST, payload);
export const updateSchoolSuccess = (payload: { schoolData: SchoolInterface }) =>
  action(SchoolsTypes.UPDATE_SCHOOL_SUCCESS, payload);
export const updateSchoolFailure = () =>
  action(SchoolsTypes.UPDATE_SCHOOL_FAILURE);

// Update School Report Limit
export const updateSchoolReportLimitRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => action(SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_REQUEST, payload);
export const updateSchoolReportLimitSuccess = (payload: {
  schoolData: SchoolInterface;
}) => action(SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_SUCCESS, payload);
export const updateSchoolReportLimitFailure = () =>
  action(SchoolsTypes.UPDATE_SCHOOL_REPORT_LIMIT_FAILURE);

// Delete Course
export const deleteSchoolRequest = (payload: object) =>
  action(SchoolsTypes.DELETE_SCHOOL_REQUEST, payload);
export const deleteSchoolSuccess = () =>
  action(SchoolsTypes.DELETE_SCHOOL_SUCCESS);
export const deleteSchoolFailure = () =>
  action(SchoolsTypes.DELETE_SCHOOL_FAILURE);

// List Courses
export const listCoursesRequest = (payload: object) =>
  action(SchoolsTypes.LIST_COURSES_REQUEST, payload);
export const listCoursesSuccess = (payload: {
  coursesList: CourseInterface[];
}) => action(SchoolsTypes.LIST_COURSES_SUCCESS, payload);
export const listCoursesFailure = () =>
  action(SchoolsTypes.LIST_COURSES_FAILURE);

// Create Course
export const createCourseRequest = (payload: object) =>
  action(SchoolsTypes.CREATE_COURSE_REQUEST, payload);
export const createCourseSuccess = () =>
  action(SchoolsTypes.CREATE_COURSE_SUCCESS);
export const createCourseFailure = () =>
  action(SchoolsTypes.CREATE_COURSE_FAILURE);

// Update Course
export const updateCourseRequest = (payload: object) =>
  action(SchoolsTypes.UPDATE_COURSE_REQUEST, payload);
export const updateCourseSuccess = () =>
  action(SchoolsTypes.UPDATE_COURSE_SUCCESS);
export const updateCourseFailure = () =>
  action(SchoolsTypes.UPDATE_COURSE_FAILURE);

// Delete Course
export const deleteCourseRequest = (payload: object) =>
  action(SchoolsTypes.DELETE_COURSE_REQUEST, payload);
export const deleteCourseSuccess = () =>
  action(SchoolsTypes.DELETE_COURSE_SUCCESS);
export const deleteCourseFailure = () =>
  action(SchoolsTypes.DELETE_COURSE_FAILURE);
